import { Link } from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import StarIcon from '@material-ui/icons/Star';

import clsx from "clsx";

import likeIcon from "../assets/like-icon.png";
import awardIconOne from "../assets/TrophyIcon.svg";
import checkIcon from "../assets/tick-icon1.svg";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 50,
    width: 36,
    height: 36,
    backgroundColor: "rgba(255,255,255,0.80)",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#fff",
    border: "1px solid #4E37DE",

    backgroundSize: 16,
    "&:before": {
      display: "block",
      width: 20,
      height: 16,
      backgroundImage: `url(${checkIcon})`,
      backgroundRepeat: "no-repeat",
      content: '""',
      position: "relative",
      top: "10px",
      left: "7px",
    },
    "input:hover ~ &": {
      backgroundColor: "#fff",
    },
  },
  starIcon: {
    color: '#FF9529',
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '50%',
    padding: '5px'
  }
});

interface DraggableImageProps {
  isSelected: boolean;
  isWinner: boolean;
  winnerIndex: number;
  src: string;
  thumbnail: string;
  caption: string;
  active: boolean;
  disabled: boolean;
  votes: number;
  openImage: (e: any, src: string) => void;
  checkboxChange: (checked: boolean, src: string) => void;
  id: string;
  submittedImages: string[];
}

export const DraggableImage = (props: DraggableImageProps) => {
  const classes = useStyles();

  return (
    <div className="col-12 col-md-4 mb-5">
      <div className="cardimgbox">
        <div>
          <a href="/vote" onClick={(e) => props.openImage(e, props.src)}>
            {props.isSelected && !props.disabled ? <div className="upperLayer"></div> : <div className="upperLayerTwo"></div>}
            <img
              className="main-image"
              src={props.thumbnail}
              alt={props.caption}
            />
          </a>
          {props.isWinner ? (
            <span className="awardBox">
              {" "}
              <img src={awardIconOne} alt="" />
              <span className="counterNum">{props.winnerIndex + 1}</span>{" "}
            </span>
          ) : null}
          {props.disabled && props.submittedImages.includes(props.id) && (
            <StarIcon fontSize="large" className={classes.starIcon} />
          )}
          {props.active && !props.disabled && (
            <div className="selected">
              <Checkbox
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={
                  <span className={clsx(classes.icon, classes.checkedIcon)} />
                }
                icon={<span className={classes.icon} />}
                inputProps={{ "aria-label": "decorative checkbox" }}
                checked={props.isSelected}
                onChange={(e) =>
                  props.checkboxChange(e.target.checked, props.src)
                }
              />
            </div>
          )}
        </div>
      </div>
      <div className="cardDetails">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="likeBox">
              <span className="cardImgTitle">{props.caption}</span>
              <Link to="#">
                <img src={likeIcon} alt="" width="18" height="16" />
              </Link>
              <span className="likeNo">{props.votes}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
